import Loading from "../ui-components/Loading";

export const LoadingWrapper = () => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <div
        style={{
          animation: "spin 1s linear infinite",
        }}
      >
        <Loading />
      </div>
    </div>
  );
}
